import { ReactNode } from "react";
import { Bubble, BubbleContent } from "@libs/zapi-ui/ds/components/bubble";
import { Message, MessageContent } from "@libs/zapi-ui/ds/components/message";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { useChatAppearance } from "./ChatAppearance";

type TUserMessageProps = {
  children: ReactNode;
  className?: string;
};

export function UserMessage({ children, className }: TUserMessageProps) {
  const appearance = useChatAppearance();
  if (appearance === "leo")
    return (
      <Message align="end" className={className}>
        <MessageContent className="items-end gap-2">
          <Bubble align="end" variant="muted">
            <BubbleContent className="typo-body-sm flex flex-col items-start gap-1.5 rounded-3xl px-4 py-2.5 *:max-w-full">
              {children}
            </BubbleContent>
          </Bubble>
        </MessageContent>
      </Message>
    );

  return (
    <div
      className={cn(
        "flex w-full items-center justify-end bg-transparent py-[12px]",
        className
      )}
    >
      <div
        className="flex max-w-[292px] flex-col items-end gap-[6px] rounded-2xl rounded-br-md bg-innoveraZinc-100 px-4 py-2.5"
      >
        <div className="flex w-full flex-col items-start gap-[6px] text-[14px] leading-[22px] text-innoveraZinc-900">
          {children}
        </div>
      </div>
    </div>
  );
}
